export default {
  'jobs': 'Jobs',
  'contact': 'Contact',
  'events': 'Events',
  'work': 'Work',
  'customers': 'Customers',
  'about': 'About',
  'home': 'Home',
};
